import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ButtonToolbar } from 'reactstrap';
import { IDLING_CONSUMPTION_PATH } from '../../../../config/paths';

const IdlingConsumptionToolbar = ({ idlingConsumptionObservationId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <Link
        className="btn btn-primary"
        to={`${IDLING_CONSUMPTION_PATH}/${idlingConsumptionObservationId}/edit`}
      >
        <i className="fa fa-pencil-square-o" /> Llenar Datos Reales
      </Link>
    </div>
  </ButtonToolbar>
);

IdlingConsumptionToolbar.propTypes = {
  idlingConsumptionObservationId: PropTypes.number.isRequired,
};

export default IdlingConsumptionToolbar;
